const potemplateType = {
  FETCH_PO_TEMPLATES: 'FETCH_PO_TEMPLATES',
  APPEND_PO_TEMPLATES: 'APPEND_PO_TEMPLATES',
  FETCH_PO_TEMPLATE_LIST: 'FETCH_PO_TEMPLATE_LIST',
  FETCHING_OLD_PO_TEMPLATES: 'FETCHING_OLD_PO_TEMPLATES',
  APPEND_OLD_PO_TEMPLATES: 'APPEND_OLD_PO_TEMPLATES',
  RESET_OLD_PO_TEMPLATES: 'RESET_OLD_PO_TEMPLATES',
  RESET_ALL_TEMPLATES: 'RESET_ALL_TEMPLATES',
  ADD_PO_TEMPLATE: 'ADD_PO_TEMPLATE',
  DELETE_PO_TEMPLATE: 'DELETE_PO_TEMPLATE',
  DELETE_OLD_PO_TEMPLATE: 'DELETE_OLD_PO_TEMPLATE',
  UPDATE_PO_TEMPLATE_ACTIVE: 'UPDATE_PO_TEMPLATE_ACTIVE',
  GET_POTEMPLATE_DETAILS: 'GET_POTEMPLATE_DETAILS',
  RESET_POTEMPLATE_DETAILS: 'RESET_POTEMPLATE_DETAILS',
  GET_PREVIEW_DATA: 'GET_PREVIEW_DATA',
  CLEAR_PREVIEW_DATA: 'CLEAR_PREVIEW_DATA',
  GET_NEW_PREVIEW_DATA: 'GET_NEW_PREVIEW_DATA',
};

export default potemplateType;
